@if (showCookieToast()) {
  <div class="fixed w-full h-full min-h-screen min-w-screen overflow-hidden grid" style="z-index: 5000">
    <div class="relative w-100 h-100 bg-surface-tile opacity-60"></div>
    <div class="absolute top-1/2 justify-self-center" style="z-index: 5000">
      <app-cookie-toast></app-cookie-toast>
    </div>
  </div>
}
<app-public-page-shell
  [blurContent]="showCookieToast()"
  [contentOffsetClass]="showHeaderAndFooter ? 'pt-10 lg-custom:pt-24 3xl:pt-14' : ''"
  [showFooter]="showFooter"
  [showHeader]="showHeaderAndFooter"
  [slimHeader]="showSlimHeader">
  @if (frontendConfig()?.isDemoEnvironment) {
    <!-- Demo/staging indicator: fixed top-left badge, shown to EVERYONE on every layout. -->
    <div class="contents" publicPageTop>
      <app-demo-environment-banner></app-demo-environment-banner>
    </div>
  }
  @if (showHeaderAndFooter) {
    <div class="contents" publicPageTop>
      @if (frontendConfig()?.activeTransaction) {
        <app-transactionbanner [frontendConfig]="frontendConfig"></app-transactionbanner>
      }
      <app-confirmation-banner></app-confirmation-banner>
      @if (isAdmin()) {
        <app-admin-form-request-message></app-admin-form-request-message>
      }
    </div>
  }

  <div class="contents" publicPageContent>
    @if (showHeaderAndFooter) {
      <app-contact-banner></app-contact-banner>
      <app-user-notification-toast></app-user-notification-toast>
      <app-user-reminder-toast></app-user-reminder-toast>
      <app-global-podcast-player></app-global-podcast-player>
    }

    @if (waitForCompanyList && !comanyListIsLoaded()) {
      <!-- ui-store-migrate (G12): <app-simple-loading-indicator> → <app-ui-spinner size="lg"> with appropriate wrapper (size + centering). The simple-loading-indicator/ folder can be sunset after this site migrates. -->
      <app-simple-loading-indicator></app-simple-loading-indicator>
    } @else {
      <router-outlet></router-outlet>
    }
  </div>
</app-public-page-shell>

<!-- Global UI Store toast surface (G14): one host for all surfaces — admin, public, marketing. -->
<app-ui-toast-surface></app-ui-toast-surface>

<!-- Second chance for an unconfirmed user to confirm attendance at the event they signed up from (#686). Outside the header/footer branch so slim layouts get it too. -->
<app-pending-event-attendance-dialog></app-pending-event-attendance-dialog>
